import React, { useEffect, useState } from "react";
import CustomDatePicker from "../../../../components/main_comps/custom_date_picker";
import CustomSelect from "../../../../components/main_comps/custom_select";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { saveAs } from "file-saver";
import {
  CLIENT,
  TRANSACTION_DEBITED,
  TRANSACTION_FAILED,
  TRANSACTION_INITIATED_MESSAGE,
  TRANSACTION_PENDING,
  TRANSACTION_REJECTED
} from "../../../../../utility/constants/valueConstants";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import moment from "moment";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import {
  SS_ROLE,
  SS_USER_HASH_ID
} from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import { fullScreenLoadingSlice } from "../../../../../data/redux/slice/loaderSlice";

const DownloadReportTransaction = ({
  programId,
  serviceProviderType,
  onClose
}) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [vanNumber, setVanNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
  const role = secureStorage.getItem(SS_ROLE);
  const dispatch = useDispatch();
  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const [selectedClient, setSelectedClient] = useState({
    label: "Client Name",
    value: ""
  });
  const [email, setEmail] = useState("");

  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box"
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20
  };

  const noteContainerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 0
  };
  const onClickDownLoadReport = () => {
    if (fromDate && !toDate) {
      enqueueSnackbar("Please select To Date", {
        variant: "error"
      });
      return;
    }
    if (fromDate && toDate) {
      const from = moment(fromDate);
      const to = moment(toDate);
      const daysDifference = to.diff(from, "days");

      if (daysDifference > 31) {
        enqueueSnackbar("Date range cannot be more than 31 days", {
          variant: "error"
        });
        return;
      }
    }
    if (!email) {
      enqueueSnackbar("Please select Email", {
        variant: "error"
      });
      return;
    }
    if (
      (fromDate && toDate) ||
      selectedClient.value ||
      selectedStatus?.value ||
      vanNumber
    ) {
      setLoading(true);
      ApiRequestGet.downloadVanTransaction({
        page: "",
        size: "",
        dateRange:
          fromDate && toDate
            ? moment(fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(toDate).format("DD/MM/YYYY")
            : "",
        business: "",
        keyWord: "",
        van: vanNumber ?? "",
        name: "",
        status: selectedStatus.value ?? "",
        clientHashId: role === CLIENT ? ss_id : selectedClient?.value ?? "",
        txnId: "",
        transferType: "",
        programId: programId,
        serviceProviderType: serviceProviderType,
        rootReferenceId: "",
        resellerId: "",
        email: email ?? ""
      })
        .then((res) => {
          if (res) {
            setLoading(false);
            if (res?.statusCode === 200) {
              onClose();
              return enqueueSnackbar(res?.message?.message, {
                variant: "success"
              });
            }
          } else {
            setLoading(false);
            onClose();
            return enqueueSnackbar("Error", {
              variant: "error"
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          onClose();
          return enqueueSnackbar("Error", {
            variant: "error"
          });
        });
    } else {
      enqueueSnackbar("Please select a filter to download", {
        variant: "error"
      });
    }
  };

  const VanTransactionStatusOptions = [
    {
      label: "None",
      value: ""
    },
    {
      label: "Success",
      value: "SUCCESS"
    },
    {
      label: "Initiated",
      value: TRANSACTION_PENDING
    },
    {
      label: "Failed",
      value: "FAILED"
    },

    {
      label: "Debited",
      value: TRANSACTION_DEBITED
    },
    {
      label: "Rejected",
      value: TRANSACTION_REJECTED
    }
  ];

  return (
    <div
      style={{
        maxHeight: 500,
        overflow: "scroll",
        position: "relative"
      }}
      className="hide-scroll-bar"
    >
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          From
        </label>
        <CustomDatePicker value={fromDate} onChange={setFromDate} />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          To
        </label>
        <CustomDatePicker
          value={toDate}
          onChange={setToDate}
          minDate={fromDate}
          disabled={fromDate ? false : true}
        />
      </div>
      {role !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            value={selectedClient}
            options={clientList}
            onChange={(data) => {
              setSelectedClient(data);
            }}
            placeholder={"Select client"}
          />
        </div>
      )}

      {/* <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          VAN
        </label>

        <CustomSelect placeholder={"VAN"} />
      </div> */}
      {/* <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Business
        </label>

        <CustomSelect placeholder={"Business"} />
      </div> */}
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          VAN/UPI
        </label>
        <CustomInput
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="VAN/UPI"
          validator=""
          type="input"
          inputStyles={{
            ...containerStyle
          }}
          value={vanNumber}
          onChange={(data) => {
            setVanNumber(data);
          }}
        />
      </div>
      <div style={{ marginTop: 20 }}>
        <CustomInput
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="EMAIL"
          validator=""
          type="input"
          inputStyles={{
            ...noteContainerStyle
          }}
          value={email}
          onChange={(data) => {
            setEmail(data);
          }}
        />
        <label
          style={{
            marginBottom: 2,
            marginTop: 0,
            color: "#6C6B6B",
            fontSize: 12,
            paddingLeft: 4,
            marginLeft: 8
          }}
        >
          Note: The Transaction report will be sent to the entered mail Id
        </label>
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Status
        </label>

        <CustomSelect
          placeholder={"Status"}
          value={selectedStatus}
          options={VanTransactionStatusOptions}
          onChange={(data) => {
            setSelectedStatus(data);
          }}
        />
      </div>

      <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
        <CustomButton
          title="Download"
          backgroundColor="#38369C"
          styles={{ width: 150 }}
          onClick={onClickDownLoadReport}
          disabled={false}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default DownloadReportTransaction;
